import { useDebouncedState } from '@/legacy-src/hooks/useDebouncedState'

import { type SessionTypeFilter } from '@/src/domains/therapist-filters/constants'
import { parseTherapistSessionTypeFilterValue } from '@/src/domains/therapist-filters/utils/parseTherapistSessionTypeFilterValue'

import { TherapistSessionTypeFilterUI } from './TherapistSessionTypeFilter.ui'

export interface TherapistSessionTypeFilterProps {
  value: SessionTypeFilter | undefined
  callback: (value: SessionTypeFilter | undefined) => void
}

export const TherapistSessionTypeFilter = ({ value: initialValue, callback }: TherapistSessionTypeFilterProps) => {
  const { value, onChange } = useDebouncedState({
    value: initialValue,
    wait: 500,
    callback,
  })

  const handleChange = (newValue: string) => {
    onChange(parseTherapistSessionTypeFilterValue(newValue))
  }

  return <TherapistSessionTypeFilterUI value={value} onChange={handleChange} />
}
